import React, { useMemo } from 'react';
import { Badge, Card } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { CalibrationSessionCard_SessionFragment } from '../../../__generated__/graphql';
import { useNamespacedTranslation } from '../../../../../hooks/useNamespacedTranslation';
import { routes } from '../../../routes';
import { useCalibrationSessionStateBadge } from '../useCalibrationSessionState';

type Props = {
  session: CalibrationSessionCard_SessionFragment;
};

const i18Path = 'performanceReview.calibration.sessionList';

export const CalibrationSessionCard: React.FC<
  React.PropsWithChildren<Props>
> = ({ session }) => {
  const t = useNamespacedTranslation(i18Path);
  const history = useHistory();

  const uniqueEmployeeCount = useMemo(() => {
    const employeeIds = new Set(
      session.employeeTopics.map((et) => et.flair__Employee__c),
    );
    return employeeIds.size;
  }, [session.employeeTopics]);

  const { label: stateLabel, bg: stateBg } = useCalibrationSessionStateBadge(
    session.flair__State__c,
  );

  const handleClick = () => {
    history.push(
      routes.calibrationWorkspace.route.create({
        sessionId: session.Id,
      }),
    );
  };

  return (
    <Card className="mb-3" role="button" onClick={handleClick}>
      <Card.Body>
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <h4 className="mb-1">{session.Name}</h4>
            <span className="text-muted small">
              {t('topics', { count: session.topics.length })}
              {' \u00b7 '}
              {t('employees', { count: uniqueEmployeeCount })}
            </span>
          </div>
          <Badge bg={stateBg}>{stateLabel}</Badge>
        </div>
      </Card.Body>
    </Card>
  );
};
